import { ChainId } from 'symbiosis-js-sdk'
import { useEffect, useState } from 'react'
import { OMNIPOOL_CONFIG } from './config'

type PoolEntry = {
	chainId: ChainId
	apr: number
	boostedApr: number
	sideApr: number
}

type APREntry = {
	chainId: ChainId
	pools: PoolEntry[]
}

export type FarmingAPR = {
	status: 'success' | 'pending' | 'failure'
	aprs: APREntry[]
	apy: (srcChainId: ChainId, dstChainId: ChainId) => number | undefined
	boostedApy: (srcChainId: ChainId, dstChainId: ChainId) => number | undefined
}

export const useFarmingAPRV2 = (): FarmingAPR => {
	const [state, setState] = useState<{
		status: 'success' | 'pending' | 'failure'
		aprs: APREntry[]
	}>({
		status: 'success',
		aprs: [],
	})

	useEffect(() => {
		fetch(`${OMNIPOOL_CONFIG.farmingURL}/v1/apr`, {
			method: 'get',
		})
			.then((response) => {
				if (response.status !== 200) {
					throw new Error('Get apr failed')
				}

				return response.json()
			})
			.then((data: APREntry[]) => {
				setState({ status: 'success', aprs: data })
			})
			.catch((error) => {
				console.warn(error)
				setState({ status: 'failure', aprs: [] })
			})
	}, [])

	const findPool = (
		srcChainId: ChainId,
		dstChainId: ChainId
	): PoolEntry | undefined => {
		if (state.status !== 'success') return
		let foundPool: PoolEntry
		state.aprs.forEach((apr) => {
			if (apr.chainId === dstChainId) {
				apr.pools.forEach((pool) => {
					if (pool.chainId === srcChainId) {
						foundPool = pool
					}
				})
			}
		})
		return foundPool
	}

	return {
		...state,
		apy: (srcChainId: ChainId, dstChainId: ChainId): number | undefined => {
			const foundPool = findPool(srcChainId, dstChainId)
			if (!foundPool) {
				return
			}
			return 100 * (foundPool.apr + foundPool.sideApr) // apr
			// return 100 * ((1 + foundPool.apr / 365) ** 365 - 1)
		},
		boostedApy: (
			srcChainId: ChainId,
			dstChainId: ChainId
		): number | undefined => {
			const foundPool = findPool(srcChainId, dstChainId)
			if (!foundPool) {
				return
			}
			return 100 * foundPool.boostedApr
		},
	}
}
